import apiClient from '../../../common/functions/api_axios_instance.function';
import { CREATE_RING } from '../../../common/constants/constants';

export const createRing = async (ringData) => {
  try {
    const response = await apiClient.post(CREATE_RING, ringData);
    return response.data;
  } catch (error) {
    console.error('Error creating ring:', error);
    throw error;
  }
};
